import type { WithAuthComponentProps } from '@/_hocs/with-auth'
import { WithAuth } from '@/_hocs/with-auth'
import { attachmentColumns } from '@/features/_columns/attachment-table-column'
import { LoadingDataTable } from '@/features/_components/loading-data-table'
import { Container } from '@/features/_components/ui/container'
import { useApplicationParams } from '@/features/_hooks/use-application-params'
import { queries } from '@/features/_lib/react-query'
import { useQuery } from '@tanstack/react-query'
import { PersonHeader } from '../_components/person-header'
import { PersonHeaderSkeleton } from '../_components/person-header.skeleton'
import { AttachmentsTable } from './_components/attachments-table'
import { CreateAttachmentButton } from './_components/create-attachment-button'

const Receipts = ({ session }: WithAuthComponentProps) => {
  const { companyId, facilityId, applicationId } = useApplicationParams()

  const { data, isLoading } = useQuery({
    ...queries.applications.detailFull(companyId, facilityId, applicationId),
    enabled: !!companyId && !!facilityId,
  })

  const { data: attachments } = useQuery({
    ...queries.attachments.list(companyId, facilityId, applicationId),
    enabled: !!companyId && !!facilityId && !!applicationId,
  })

  if (isLoading || !data)
    return (
      <Container className="h-full px-14 py-10 gap-6">
        <PersonHeaderSkeleton />
        <LoadingDataTable columns={attachmentColumns} />
      </Container>
    )

  const { application, facility } = data
  const userType = session.user.userType as 'staff' | 'tenant'
  const existingFilenames = (attachments ?? []).map((a) => a.filename)

  return (
    <Container className="h-full px-14 py-10 gap-6">
      <PersonHeader
        application={application}
        person={application.person}
        facility={facility}
        userType={session.user.userType}
      />

      <div className="flex w-full items-center justify-between">
        <h2 className="text-xl font-semibold text-brand-grayscale-12">Anexos</h2>
        <CreateAttachmentButton
          applicationId={application.id}
          existingFilenames={existingFilenames}
          userType={userType}
        />
      </div>

      <AttachmentsTable
        applicationId={application.id}
        attachments={attachments ?? []}
        userType={userType}
      />
    </Container>
  )
}

export default WithAuth(Receipts, { allowedFor: ['staff', 'tenant'] })
